var React = require('react');

function Cr (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#0000b4","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 75.4h640v322.3H0z","key":1}),React.createElement("path",{"fill":"#d90000","d":"M0 157.7h640v157.7H0z","key":2})]));
}

Cr.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Cr;

Cr.default = Cr;
